/**
 * Segmentos de URL del tipo "verificar-bujia-28".
 *
 * El slug es decorativo (para que el link se pueda leer y para SEO) y el id del
 * final es lo único que se usa para resolver. Así el link sobrevive a que
 * renombren una falla en el admin, y a que dos fallas se llamen igual: las
 * soluciones del servicio técnico no tienen slug propio, solo id.
 */

export function slugify(text) {
    if (!text) return '';
    return String(text)
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // saca acentos
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 60);
}

/** { id: 28, name: 'Verificar bujía' } -> "verificar-bujia-28" */
export function slugWithId(id, name) {
    if (id === null || typeof id === 'undefined') return null;
    const slug = slugify(name);
    return slug ? `${slug}-${id}` : String(id);
}

/** "verificar-bujia-28" -> 28 | "28" -> 28 | cualquier otra cosa -> null */
export function idFromSlug(segment) {
    if (!segment) return null;
    const match = String(segment).match(/(\d+)$/);
    return match ? Number(match[1]) : null;
}
